import React, { useEffect } from 'react';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import Menu from 'component/Menu';
import Footer from 'component/Footer';

import './PageAccess.scss';

type Props = {
  testPath: string,
}

const PageAccess: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // Effect
  useEffect(() => {
    // タイトルなど
    // document.title = 'アクセス';

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  return (
    <div id="PageAccess">
      <Header />
      <Menu />
      <div className="bg">
        <div className="topTitle">
          <h2 className="c-h2">ACCESS</h2>
        </div>
        <div className="lead">ご来場方法</div>
        <div className="bgWhite">
          <div className="map"><iframe title="コクヨ東京ショールーム" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3242.9031295008185!2d139.7415748015747!3d35.630114539829634!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x640ce08077f8eb4e!2z44Kz44Kv44Oo5p2x5Lqs44K344On44O844Or44O844Og!5e0!3m2!1sja!2sjp!4v1606275433854!5m2!1sja!2sjp" frameBorder="0" aria-hidden="false"></iframe></div>
          <p className="para1">
            羽田空港からは京浜急行直通を利用すればわずか20分。東京駅からもわずか10分足らずです。<br/>
            お帰りも便利ですので、夕刻までの時間を有意義にお使いいただけます。
          </p>
          <p className="para2">
            <strong>新幹線停車でますます便利になった品川駅</strong><br />
            東海道新幹線の停車で、東京の新しい玄関口となった品川駅。東海・関西地方からのアクセスがぐっと便利になりました。
          </p>
          <p className="para3">
            <strong>羽田空港からも京浜急行でわずか20分</strong><br />
            羽田空港からのアクセスも京浜急行直通で便利です。<br />
京浜急行利用　羽田空港→京急品川20分
          </p>
          <p className="para4">
            <strong>東京駅からわずか10分！</strong><br />
            東京駅からもわずか10分ですので、東北・北陸からのアクセスも至便です。<br />
東京→品川（ＪＲ東海道線・横須賀線・山手線・京浜東北線利用）8～12分
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PageAccess;
